export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Bravo!', 'Minunat!', 'Bine lucrat!']
export const GAME_COPIED_MESSAGE = 'Jocul a fost copiat în clipboard.'
export const ABOUT_GAME_MESSAGE = 'Despre acest joc'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Nu sunt destule litere.'
export const WORD_NOT_FOUND_MESSAGE = 'Cuvânt negăsit'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Cuvântul a fost ${solution}`
export const ENTER_TEXT = 'Trimite'
export const DELETE_TEXT = 'Șterge'
export const STATISTICS_TITLE = 'Statistici'
export const GUESS_DISTRIBUTION_TEXT = 'Distribuția ghicirilor'
export const NEW_WORD_TEXT = 'Cuvânt nou'
export const SHARE_TEXT = 'Laudă-te!'
export const TOTAL_TRIES_TEXT = 'Totalul încercărilor'
export const SUCCESS_RATE_TEXT = 'Rata de succes'
export const CURRENT_STREAK_TEXT = 'Linia curentă'
export const BEST_STREAK_TEXT = 'Cea mai bună linie'